import { render, staticRenderFns } from "./documentacaoVeiculo.vue?vue&type=template&id=4e402ea6"
import script from "./documentacaoVeiculo.vue?vue&type=script&lang=js"
export * from "./documentacaoVeiculo.vue?vue&type=script&lang=js"
import style0 from "./documentacaoVeiculo.vue?vue&type=style&index=0&id=4e402ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports